import HomePage from "./components/pages/HomePage";
import NotFoundPage from "./components/pages/NotFoundPage";
import PanelLeftPage from "./components/pages/PanelLeftPage";
// INIT-GENERATOR.PHP importConfig
import CompetitorsPage from "./components/pages/CompetitorsPage";
import InternalControlPage from "./components/pages/InternalControlPage";
// END-GENERATOR.PHP importConfig

export default [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/panel-left/",
    component: PanelLeftPage,
  },
  // INIT-GENERATOR.PHP jsonConfig
  {
    path: "/competitors/",
    component: CompetitorsPage,
  },
  {
    path: "/internal-control/",
    component: InternalControlPage,
  },
  // END-GENERATOR.PHP jsonConfig
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];



// WEBPACK FOOTER //
// ./src/routes.ts